import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate } from '../../Common/Helpers';
import { RoutePaths } from '../../Common/ClientRoutes';

const singleCompany = props => {
    return (
        <tr>
            <td>
                <Link to={RoutePaths.DETAILS_COMPANY(props.id)}>{props.name ? props.name : ' '}</Link>
            </td>
            <td />
            <td>{props.registeredOn ? formatDate(props.registeredOn, true) : 'N/A'}</td>
            <td />
            <td>{props.owner ? props.owner : 'N/A'}</td>
            <td />
            <td>{props.pharmacies ? props.pharmacies : 'N/A'}</td>
            <td />
            <td>{props.employees ? props.employees : 'N/A'}</td>
            <td />
            <td>{props.orders ? props.orders : 'N/A'}</td>
            <td className="qf-hidden-box">
                <Link to={RoutePaths.EDIT_COMPANY(props.id)}>
                    <i className="fa fa-pencil-square-o" />
                </Link>
            </td>
        </tr>
    );
};

export default singleCompany;



// WEBPACK FOOTER //
// ./src/customModules/Companies/components/Single-company.js